/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

'use es6';

import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import styled from 'styled-components';
import UIButton from 'UIComponents/button/UIButton';
import H1 from 'UIComponents/elements/headings/H1';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIFlex from 'UIComponents/layout/UIFlex';
import UISection from 'UIComponents/section/UISection';
import { GYPSUM } from 'HubStyleTokens/colors';
import PricingCard from './PricingCard';
import UICardGrid from 'UIComponents/card/UICardGrid';
import { connect } from 'react-redux';
import { setUserGuideSettingsAndReturnUrl } from '../../actions/GettingStartedActions';
import { onboardingSettingsExperienceMap, onboardingSettingsHubMap } from '../../constants/GettingStatedConsts';
import { getPricingPageUrl } from '../../utils/RoutingUtils';
import { getAccountsProductsByPortal } from '../../selectors/accountsSelectors';
import { getHighestHubPlan } from '../../utils/pricingUtils';
import { useMemo, useState } from 'react';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import UIList from 'UIComponents/list/UIList';
import UICheckbox from 'UIComponents/input/UICheckbox';
import { currencies, hubPricingFeaturesI18Nkeys } from '../../constants/AcademyToSoftwarePricingData';
import UsageTracker from '../../utils/UsageTracker';
import { getHubPricingData } from '../../selectors/productsSelectors';
import useMediaQuery from '../../hooks/useMediaQuery';
import { GRID_BREAKPOINT_MEDIUM, GRID_BREAKPOINT_SMALL } from 'HubStyleTokens/sizes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledSection = styled(UISection).withConfig({
  displayName: "ModalPricingSection__StyledSection",
  componentId: "e5419e-0"
})(["background-color:", ";padding:40px;text-align:center;@media (max-width:", "){padding:40px 16px;}"], GYPSUM, GRID_BREAKPOINT_SMALL);
const BottomButtonContainer = styled.div.withConfig({
  displayName: "ModalPricingSection__BottomButtonContainer",
  componentId: "e5419e-1"
})(["display:flex;justify-content:center;flex-wrap:wrap;@media (max-width:", "){flex-direction:column;}@media (max-width:", "){.bottom-button{width:100%;margin-left:0 !important;&:not(:last-child){margin-bottom:8px !important;}}}"], GRID_BREAKPOINT_SMALL, GRID_BREAKPOINT_MEDIUM);
const ModalPricingSection = ({
  portalId,
  hub,
  sectionProps,
  setOnboardingSettings,
  onCTAClick,
  ownedProducts,
  hubPricingData,
  priceLoading
}) => {
  const [selectedCurrency, setSelectedCurrency] = useState('USD');
  const isSmallSize = useMediaQuery(`(max-width: ${GRID_BREAKPOINT_SMALL})`);
  const pricingCards = useMemo(() => Object.keys(hubPricingFeaturesI18Nkeys[hub]).map(pricingLevel => /*#__PURE__*/_jsx(PricingCard, {
    currency: selectedCurrency,
    features: hubPricingFeaturesI18Nkeys[hub][pricingLevel].map(feature => /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: `learningCenter.softwareDesirability.modal.hubs.${hub}.pricingFeatures.${pricingLevel}.${feature}`
    }, feature)),
    isCurrentPlan: ownedProducts && getHighestHubPlan(ownedProducts, hub) === pricingLevel,
    level: pricingLevel,
    price: hubPricingData[hub] && hubPricingData[hub][pricingLevel] && hubPricingData[hub][pricingLevel][selectedCurrency] || 0,
    priceLoading: priceLoading
  }, pricingLevel)), [hub, hubPricingData, ownedProducts, priceLoading, selectedCurrency]);
  return /*#__PURE__*/_jsxs(StyledSection, Object.assign({
    flush: true
  }, sectionProps, {
    children: [/*#__PURE__*/_jsx(H1, {
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "learningCenter.softwareDesirability.modal.pricingSection.heading",
        options: {
          hubName: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `learningCenter.softwareDesirability.modal.hubs.${hub}.name`
          })
        }
      })
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.softwareDesirability.modal.pricingSection.subheading"
    }), /*#__PURE__*/_jsx(UIFlex, {
      className: "m-top-8",
      justify: "center",
      children: /*#__PURE__*/_jsxs(UICardGrid, {
        gutterSize: 16,
        style: {
          gridTemplateColumns: !isSmallSize ? 'repeat(auto-fit, 516px)' : 'unset',
          justifyContent: 'center',
          width: '100%',
          position: 'relative'
        },
        children: [/*#__PURE__*/_jsx(UIFlex, {
          justify: ['starter', 'enterprise'].includes(getHighestHubPlan(ownedProducts, hub)) ? 'start' : 'end',
          style: !isSmallSize ? {
            gridColumn: '1 / -1',
            position: 'absolute',
            top: '-8px'
          } : {},
          children: /*#__PURE__*/_jsxs(UIFlex, {
            align: "center",
            style: {
              flexGrow: 0
            },
            children: [/*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.softwareDesirability.modal.pricingSection.currency"
            }), /*#__PURE__*/_jsx(UIDropdown, {
              buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
                message: `learningCenter.softwareDesirability.modal.pricingSection.currencies.${selectedCurrency}`
              }),
              buttonUse: "transparent",
              "data-test-id": "academy-to-software-desirability-modal-currency-dropdown",
              shouldCloseOnClick: () => true,
              children: /*#__PURE__*/_jsx(UIList, {
                children: currencies.map(currency => /*#__PURE__*/_jsx(UICheckbox, {
                  checked: currency === selectedCurrency,
                  "data-test-id": `academy-to-software-desirability-modal-currency-${currency}`,
                  onChange: () => {
                    UsageTracker.track('interaction', {
                      action: 'academy-to-software-modal-currency-changed',
                      hub,
                      ownedPlan: getHighestHubPlan(ownedProducts, hub),
                      currency
                    });
                    setSelectedCurrency(currency);
                  },
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: `learningCenter.softwareDesirability.modal.pricingSection.currencies.${currency}`
                  })
                }, currency))
              })
            })]
          })
        }), /*#__PURE__*/_jsx(UICardGrid, {
          gutterSize: 16,
          style: {
            gridTemplateColumns: !isSmallSize && 'repeat(2, 250px)',
            justifyContent: 'center',
            alignItems: 'end'
          },
          children: pricingCards.slice(0, 2)
        }), /*#__PURE__*/_jsx(UICardGrid, {
          gutterSize: 16,
          style: {
            gridTemplateColumns: !isSmallSize && 'repeat(2, 250px)',
            justifyContent: 'center',
            alignItems: 'end'
          },
          children: pricingCards.slice(2)
        })]
      })
    }), /*#__PURE__*/_jsxs(BottomButtonContainer, {
      className: "m-top-4",
      children: [/*#__PURE__*/_jsxs(UIButton, {
        className: "bottom-button",
        "data-test-id": "academy-to-software-desirability-modal-pricing-section-user-guide-button",
        external: true,
        onClick: () => {
          UsageTracker.track('interaction', {
            action: 'academy-to-software-modal-user-guide-click',
            hub,
            ownedPlan: getHighestHubPlan(ownedProducts, hub),
            section: 'pricing'
          });
          setOnboardingSettings(onboardingSettingsHubMap[hub.toUpperCase()], onboardingSettingsExperienceMap.NO_EXPERIENCE).then(redirectUrl => {
            onCTAClick();
            window.open(redirectUrl, '_blank');
          });
        },
        style: {
          height: '52px'
        },
        use: "primary",
        children: [/*#__PURE__*/_jsx(FormattedReactMessage, {
          message: `learningCenter.softwareDesirability.modal.${getHighestHubPlan(ownedProducts, hub) === 'free' ? 'primaryCTA' : 'primaryCTAPaid'}`,
          options: {
            hubName: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `learningCenter.softwareDesirability.modal.hubs.${hub}.name`
            })
          }
        }), /*#__PURE__*/_jsx(UIIcon, {
          name: "externalLink",
          size: 14
        })]
      }), /*#__PURE__*/_jsx(UIButton, {
        className: "bottom-button",
        "data-test-id": "academy-to-software-desirability-modal-pricing-section-features-button",
        external: true,
        href: getPricingPageUrl(portalId, hub),
        onClick: () => {
          UsageTracker.track('interaction', {
            action: 'academy-to-software-modal-features-pricing-click',
            hub,
            ownedPlan: getHighestHubPlan(ownedProducts, hub),
            section: 'pricing'
          });
          onCTAClick();
        },
        style: {
          height: '52px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        },
        target: "_blank",
        use: "secondary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          className: "m-right-1",
          message: "learningCenter.softwareDesirability.modal.secondaryCTA"
        })
      })]
    })]
  }));
};
const mapStateToProps = state => {
  return {
    portalId: state.auth.portal.portal_id,
    ownedProducts: getAccountsProductsByPortal(state),
    hubPricingData: getHubPricingData(state)
  };
};
const mapDispatchToProps = {
  setOnboardingSettings: setUserGuideSettingsAndReturnUrl
};
export default connect(mapStateToProps, mapDispatchToProps)(ModalPricingSection);